module.exports = __webpack_public_path__ + "img/logo.cacadf9f.png";